import store from '@/store/indexStore';
import axios from '@/composable/axios';
import { handleAxiosCommonException, isSmartPhone } from '@/composable/common';
import { onsAlert } from '@/composable/onsen_common';
import { MATERIAL_UPLORD_STATUS, AXIOS_TIMEOUT } from '@/composable/constant_common';

/**
 * materialStoreのステータスをDB登録失敗に更新
 */
export function updateMaterialStoreStatusToUploadFailure(materialUrlList) {
  const materialUploadingList = store.getters['materialStore/getMaterialUploadingList'];
  // materialUploadingListのmaterialUploadStatusを更新する
  const tmpMaterialUploadingList = materialUploadingList.map(
    (item) =>
      materialUrlList.includes(item.materialUrl)
        ? { ...item, materialUploadStatus: MATERIAL_UPLORD_STATUS.MATERIAL_REGISTERED_ERR } // 新しいオブジェクトを作成してmaterialUploadStatusを更新
        : item // 一致しない場合はそのままitemを返す
  );
  store.commit('materialStore/setMaterialUploadingList', tmpMaterialUploadingList);
}

/**
 * マテリアル登録
 */
export async function postMaterial(uploadingMaterialObjectList, materialFileList, materialUrlList) {
  const durationList = [];

  // 動画の秒数をリストに格納
  for (let i = 0; i < uploadingMaterialObjectList.length; i += 1) {
    if (uploadingMaterialObjectList[i].duration) {
      durationList[i] = uploadingMaterialObjectList[i].duration;
    }
  }

  // ユーザID,マテリアル（バイナリ）,動画秒数をパラメータに追加
  const MaterialParameters = new FormData();
  MaterialParameters.append('userId', store.getters['userInformation/getUserId']);

  for (let i = 0; i < materialFileList.length; i += 1) {
    // materialFileListの各ファイルをバイナリデータとして追加
    MaterialParameters.append('materialList', materialFileList[i]);
    // マテリアルURL
    MaterialParameters.append('materialUrlList', materialUrlList[i]);
  }
  MaterialParameters.append('materialDurationList', durationList);

  // マテリアル登録API呼び出し
  axios
    .post('/material', MaterialParameters, {
      headers: { Authorization: localStorage.getItem('token') },
      timeout: isSmartPhone() ? AXIOS_TIMEOUT : 0,
    })
    .then()
    .catch(() => {
      // materialStoreのステータスを更新
      updateMaterialStoreStatusToUploadFailure(materialUrlList);
      // 非同期実行のためエラーメッセージは表示しない（登録失敗マテリアルを一覧に表示してユーザに伝える想定）
      // onsAlert(`アップロードに失敗しました。再度お試しください。`);
    });
}

/**
 * 配信グループ登録
 */
export async function postStreamGroup(method, StreamGroupParameters) {
  // 配信グループ登録(更新)API呼び出し
  return new Promise((resolve, reject) => {
    axios({
      method,
      url: '/streamgroup',
      data: StreamGroupParameters,
      headers: { Authorization: localStorage.getItem('token') },
    })
      .then(() => resolve())
      .catch((error) => {
        onsAlert(`アップロードに失敗しました。再度お試しください。`);
        reject(error);
      });
  });
}

/**
 * 配信グループの配信情報登録
 */
export function postStreamingStreamGroup(streamGroupId) {
  // 配信ステータスデータセット
  const StreamingStreamGroupParameters = new FormData();
  StreamingStreamGroupParameters.append('userId', store.getters['userInformation/getUserId']);
  StreamingStreamGroupParameters.append('streamGroupId', streamGroupId);
  // 配信グループ配信登録API呼び出し
  const axiosResult = new Promise((resolve, reject) => {
    axios
      .post('/streamgroup/streaming', StreamingStreamGroupParameters, {
        headers: { Authorization: localStorage.getItem('token') },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        // Axios共通エラーハンドリング処理をCall
        handleAxiosCommonException(error);
        reject(error);
      });
  });
  return axiosResult;
}

/**
 * 配信グループの配信ステータス更新
 */
export function putStreamingStreamGroup(streamGroupId, uploadStatusId) {
  // 配信ステータスデータセット
  const StreamingStreamGroupParameters = new FormData();
  StreamingStreamGroupParameters.append('userId', store.getters['userInformation/getUserId']);
  StreamingStreamGroupParameters.append('streamGroupId', streamGroupId);
  StreamingStreamGroupParameters.append('uploadStatusId', uploadStatusId);

  // 配信ステータス更新API呼び出し
  const axiosResult = new Promise((resolve, reject) => {
    axios
      .put('/streamgroup/streaming/uploadstatus', StreamingStreamGroupParameters, {
        headers: { Authorization: localStorage.getItem('token') },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        // Axios共通エラーハンドリング処理をCall
        handleAxiosCommonException(error);
        reject(error);
      });
  });
  return axiosResult;
}

/**
 * 配信グループの配信予約情報登録
 */
export function postStreamGroupSchedule(
  streamGroupId,
  daysOfWeek,
  streamingStartTime,
  streamingEndTime
) {
  // 配信開始・終了時間を時分に分けてそれぞれ変数へ代入
  const [streamingStartHour, streamingStartMinute] = [...streamingStartTime.split(':')];
  const [streamingEndHour, streamingEndMinute] = [...streamingEndTime.split(':')];

  // 配信予約情報セット
  const StreamGroupScheduleParameters = new FormData();
  StreamGroupScheduleParameters.append('userId', store.getters['userInformation/getUserId']);
  StreamGroupScheduleParameters.append('streamGroupId', streamGroupId);
  StreamGroupScheduleParameters.append('streamingStartHour', streamingStartHour);
  StreamGroupScheduleParameters.append('streamingStartMinute', streamingStartMinute);
  StreamGroupScheduleParameters.append('streamingEndHour', streamingEndHour);
  StreamGroupScheduleParameters.append('streamingEndMinute', streamingEndMinute);
  daysOfWeek.forEach((dayOfWeek, index) => {
    StreamGroupScheduleParameters.append(`daysOfWeek[${index}]`, dayOfWeek);
  });

  // 配信グループ配信予約登録API呼び出し
  const axiosResult = new Promise((resolve, reject) => {
    axios
      .post('/streamgroup/schedule', StreamGroupScheduleParameters, {
        headers: { Authorization: localStorage.getItem('token') },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        // Axios共通エラーハンドリング処理をCall
        handleAxiosCommonException(error);
        reject(error);
      });
  });
  return axiosResult;
}

/**
 * 配信グループの配信予約情報登録
 */
export function putStreamGroupSchedule(
  streamGroupId,
  daysOfWeek,
  streamingStartTime,
  streamingEndTime,
  streamingScheduleId
) {
  // 配信開始・終了時間を時分に分けてそれぞれ変数へ代入
  const [streamingStartHour, streamingStartMinute] = [...streamingStartTime.split(':')];
  const [streamingEndHour, streamingEndMinute] = [...streamingEndTime.split(':')];

  // 配信予約情報セット
  const StreamGroupScheduleParameters = new FormData();
  StreamGroupScheduleParameters.append('userId', store.getters['userInformation/getUserId']);
  StreamGroupScheduleParameters.append('streamGroupId', streamGroupId);
  StreamGroupScheduleParameters.append('streamingScheduleId', streamingScheduleId);
  StreamGroupScheduleParameters.append('streamingStartHour', streamingStartHour);
  StreamGroupScheduleParameters.append('streamingStartMinute', streamingStartMinute);
  StreamGroupScheduleParameters.append('streamingEndHour', streamingEndHour);
  StreamGroupScheduleParameters.append('streamingEndMinute', streamingEndMinute);
  daysOfWeek.forEach((dayOfWeek, index) => {
    StreamGroupScheduleParameters.append(`daysOfWeek[${index}]`, dayOfWeek);
  });

  // 配信グループ配信予約登録API呼び出し
  const axiosResult = new Promise((resolve, reject) => {
    axios
      .put('/streamgroup/schedule', StreamGroupScheduleParameters, {
        headers: { Authorization: localStorage.getItem('token') },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        // Axios共通エラーハンドリング処理をCall
        handleAxiosCommonException(error);
        reject(error);
      });
  });
  return axiosResult;
}

/**
 * 配信予約アップロードステータス更新
 */
export function putStreamingScheduleUploadStatus(streamingScheduleId, uploadStatusId) {
  // 配信予約アップロード更新データセット
  const StreamingScheduleUploadStatusParameter = new FormData();
  StreamingScheduleUploadStatusParameter.append(
    'userId',
    store.getters['userInformation/getUserId']
  );
  StreamingScheduleUploadStatusParameter.append('streamingScheduleId', streamingScheduleId);
  StreamingScheduleUploadStatusParameter.append('uploadStatusId', uploadStatusId);

  // 配信予約アップロードステータス更新API呼び出し
  const axiosResult = new Promise((resolve, reject) => {
    axios
      .put('/streamgroup/scheduled/uploadstatus', StreamingScheduleUploadStatusParameter, {
        headers: { Authorization: localStorage.getItem('token') },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        // Axios共通エラーハンドリング処理をCall
        handleAxiosCommonException(error);
        reject(error);
      });
  });
  return axiosResult;
}

/**
 * モニターの削除
 */
export function deleteMonitor(monitorId) {
  // モニター削除データセット
  const deleteMonitorParameter = new FormData();
  deleteMonitorParameter.append('userId', store.getters['userInformation/getUserId']);
  deleteMonitorParameter.append('monitorId', monitorId);

  // モニター削除API呼び出し
  const axiosResult = new Promise((resolve, reject) => {
    axios
      .delete('/monitor', {
        headers: { Authorization: localStorage.getItem('token') },
        data: deleteMonitorParameter,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        // Axios共通エラーハンドリング処理をCall
        handleAxiosCommonException(error);
        reject(error);
      });
  });
  return axiosResult;
}

/**
 * アップロード失敗素材削除処理
 */
export function deleteFailureUploadMaterials() {
  const DeleteMaterialParameters = new URLSearchParams();
  DeleteMaterialParameters.append('userId', store.getters['userInformation/getUserId']);
  axios
    .delete('/material/failure', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      data: DeleteMaterialParameters,
    })
    .then()
    .catch((error) => {
      // Axios共通エラーハンドリング処理をCall
      handleAxiosCommonException(error);
    });
}

/**
 * アップロード失敗配信グループ削除処理
 */
export async function deleteFailureUploadStreamGroups() {
  const DeleteStreamGroupParameters = new URLSearchParams();
  DeleteStreamGroupParameters.append('userId', store.getters['userInformation/getUserId']);
  return new Promise((resolve, reject) => {
    axios
      .delete('/streamgroup/failure', {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
        data: DeleteStreamGroupParameters,
      })
      .then(() => {
        resolve();
      })
      .catch((error) => {
        // Axios共通エラーハンドリング処理をCall
        handleAxiosCommonException(error);
        reject(error);
      });
  });
}
